export default __webpack_public_path__ + "static/media/icon-templates.6e95884a.svg";